import { Card, CardContent, Typography } from "@mui/material";
import { formatNumber } from "../../helpers/formatNumber";

export const RTFOSeismicityFracEnergy = ({ fracEnergy, darkMode }) => {

  return (
    <div style={{margin: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around'}}>
      {['totalInjectionEnergy', 'totalFracEnergy', 'energyLost', 'percentEnergyLost'].map(param => {
        return (
          <Card key={param} style={{width: 300, height: 150}} elevation={0}>
            <CardContent>
              <Typography variant="caption" color="textPrimary">{getParamName(param)}</Typography>

              <Typography style={{textAlign: 'center', marginTop: 40}} variant="h4">
                <span><b>{formatNumber(getParamValue(param))}</b></span> <span style={{fontSize: 16}}><b>{getParamUnits(param)}</b></span>
              </Typography>
            </CardContent>
          </Card>
        )
      })}
    </div>
  );

  function getParamName(param) {
    switch(param) {
      case 'totalInjectionEnergy':
        return 'Total Injection Energy'
      case 'totalFracEnergy':
        return 'Total Fracture Energy'
      case 'energyLost':
        return 'Energy Lost'
      case 'percentEnergyLost':
        return 'Percent Energy Lost'
      default:
        return ''
    }
  }

  function getParamValue(param) {
    switch(param) {
      case 'totalInjectionEnergy':
        return fracEnergy?.Ei?.toFixed(2) || 0;
      case 'totalFracEnergy':
        return fracEnergy?.Ef?.toFixed(2) || 0;
      case 'energyLost':
        return fracEnergy?.El?.toFixed(2) || 0;
      case 'percentEnergyLost':
        return fracEnergy?.percentEnergyLost ? ((fracEnergy?.percentEnergyLost * 100))?.toFixed(2) : 0;
      default:
        return ''
    }
  }

  function getParamUnits(param) {
    switch(param) {
      case 'totalInjectionEnergy':
        return 'MJ'
      case 'totalFracEnergy':
        return 'MJ'
      case 'energyLost':
        return 'MJ'
      case 'percentEnergyLost':
        return '%'
      default:
        return ''
    }
  }
};
